import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import { Grid, Stack, Typography, createTheme, useMediaQuery } from '@mui/material';
import './style.css';
import { datetimeFormatter } from '../../utils/datetimeFormatter';
import dayjs from 'dayjs';
import { isEmpty } from '../../utils/helper';

export const ReadOnlyResidentialBuildingDetails = observer(({ details }) => {
  const theme = createTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const getData = (value) => {
    return isEmpty(value) ? '_' : value;
  };

  return (
    <Paper sx={{ px: '30px', py: '20px', pb: '40px' }}>
      <Stack spacing={4}>
        <Stack spacing={3}>
          <Grid rowGap={2} container justifyContent={'space-evenly'}>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Stack direction={'row'} width={'100%'} height={'100%'} spacing={4}>
                <Stack direction={'column'} spacing={2} sx={{ color: '#626A72', fontWeight: '500' }}>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Ground Floor
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Living Room
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Common Toilet
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Kitchen
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Prayer Room
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Staircase
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Lift
                  </Typography>
                </Stack>
                <Stack direction={'column'} spacing={2}>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.groundFloor)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.livingRoom)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.commonToilet)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.kitchen)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {details?.prayerRoom?.toString()}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.staircase)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {details?.lift?.toString()}
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Stack direction={'row'} width={'100%'} height={'100%'} spacing={4}>
                <Stack direction={'column'} spacing={2} sx={{ color: '#626A72', fontWeight: '500' }}>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Bedroom
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Bedroom Additional Details
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Utility
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Laundry
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Gym
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Home Theatre
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Additional Details
                  </Typography>
                </Stack>
                <Stack direction={'column'} spacing={2}>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.bedRoom)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.bedRoomAdditionalDetails)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {details?.utility?.toString()}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.laundry)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.gym)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.homeTheater)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.additionalDetails)}
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
          </Grid>
        </Stack>
      </Stack>
    </Paper>
  );
});
